import toolsClient from "@/api/toolsClient"

export const PODCAST_GEOBLOCK_TYPE_COUNTRIES = "countries"
export const PODCAST_GEOBLOCK_TYPE_IP = "ip"

export const getPodcastGeoblock = async (podcastKey, type = PODCAST_GEOBLOCK_TYPE_COUNTRIES) => {
  const { data } = await toolsClient.get(`/podcasts/${podcastKey}/geoblock/${type}`)

  return data
}

export const updatePodcastGeoblock = async (podcastKey, data, type = PODCAST_GEOBLOCK_TYPE_COUNTRIES) => {
  const response = await toolsClient.put(`/podcasts/${podcastKey}/geoblock/${type}`, data)

  return response.data
}

export const getPodcastGeoblockIP = async (podcastKey) => {
  return await getPodcastGeoblock(podcastKey, PODCAST_GEOBLOCK_TYPE_IP)
}

export const updatePodcastGeoblockIP = async (podcastKey, data) => {
  return await updatePodcastGeoblock(podcastKey, data, PODCAST_GEOBLOCK_TYPE_IP)
}
